import { render, staticRenderFns } from "./BaseContainerWebWrapper.vue?vue&type=template&id=5db01477&scoped=true&lang=pug&"
import script from "./BaseContainerWebWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseContainerWebWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BaseContainerWebWrapper.vue?vue&type=style&index=0&id=5db01477&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db01477",
  null
  
)

export default component.exports